import React from 'react'
import { useTranslation } from 'react-i18next'

const StandardFooter = () => {
  const { t } = useTranslation()

  return (
    <div className="footer-bottom text-center py-2">
      <p className="mb-0 small text-muted">
        &copy; {new Date().getFullYear()} {t('COPYRIGHT')}
      </p>
    </div>
  )
}

export default StandardFooter
